import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installFetchAccessNotice } from './accessNotice';  // U2b

installFetchAccessNotice();
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// R10e36.80.4-F1004: Kill any registered service worker on load.
// This defeats stale caches that cause CONNECTION_RESET after backend restart.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
      console.log('R10e36.80.4-F1004: Unregistered service worker', registration.scope);
    }
  });
  // Also clear all SW caches
  if ('caches' in window) {
    caches.keys().then((names) => {
      for (const name of names) {
        caches.delete(name);
        console.log('R10e36.80.4-F1004: Deleted cache', name);
      }
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// R10e36.80.4-F1004: Unregister service worker instead of register
// Previously: serviceWorkerRegistration.register();
serviceWorkerRegistration.unregister();
